import { createFileRoute } from "@tanstack/react-router";

import { DiscoveryEntry } from "../features/discovery/DiscoveryEntry.tsx";

export const Route = createFileRoute("/_app/discovery/")({
  component: DiscoveryEntry,
});
